import {
  NgClass,
  NgFor,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
} from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Facet, ValuesEntity } from 'src/app/classes/facet';
import { MercuryService } from 'src/app/service/mercury.service';
import { SessionStorageService } from 'src/app/service/sessionstorage.service';

@Component({
  selector: 'mercury-filter-accordion',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgFor,
    NgSwitch,
    NgSwitchDefault,
    NgSwitchCase,
    FormsModule,
  ],
  templateUrl: './filter-accordion.component.html',
  styleUrls: ['./filter-accordion.component.scss'],
})
export class FilterAccordionComponent implements OnInit {
  @Input() facet!: Facet;
  @Input() exclude: boolean = false;
  _open: boolean = true;
  _uniqueSizes: any;

  ngOnInit(): void {
    this._open =
      Boolean(
        this.sessionStorage.getItem(this.facet.facet + ':' + this.facet.type)
      ) || !this.facet.minimized;

    if (this.facet.type === 'hierarchy') {
      this.facet.values.some((value) => {
        if (value.children?.some((child) => child.active)) {
          value._open = true;
          this._open = true;
          return true;
        }
        return false;
      });
    }

    if (this.facet.type === 'colour') {
      this.facet.values.forEach((entry) => {
        if (entry?.meta?.img && !entry.meta.img.includes('url(')) {
          entry.meta.img = `url('${entry.meta.img}')`;
        }
      });
    }

    if (this.facet.type === 'variant_size') {
      this._uniqueSizes = Array.from(
        new Set(this.facet.values.map((value) => value.group))
      );
    }
  }

  preventDefault($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
  }

  constructor(
    private utilityService: MercuryService,
    private sessionStorage: SessionStorageService
  ) {}

  selectFilter(filter: ValuesEntity) {
    filter._active = !filter.active;
    this.utilityService.selectValueFromFacet(filter, this.exclude);
  }

  selectMultiFilter(filter: ValuesEntity) {
    filter._active = !filter.active;
    filter.children?.forEach((x) => (x._active = filter._active));
    this.utilityService.selectMultiFilter(filter);
  }

  selectMultiFilterChild(filter: ValuesEntity, value: ValuesEntity) {
    value._active = !value.active;
    filter._active = value._active;
    this.utilityService.selectMultiFilterChild(filter, value);
  }

  clickedInside($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  async openFacet($event: any) {
    this._open = !this._open;
    this.sessionStorage.setItem(
      this.facet.facet + ':' + this.facet.type,
      this._open ? 'true' : 'false'
    );
  }

  openChildFacet(value: ValuesEntity) {
    value._open = !value._open;
  }
}
